import { createSlice, createSelector } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export interface SupplementFilterStateType {
    search: string;
    page: number;
    orderBy: string;
    orderDir: string;
}

const initialState: SupplementFilterStateType = {
    search: '',
    page: 1,
    orderBy: 'created_at',
    orderDir: '-',
};

export const supplementFilterSlice = createSlice({
    name: 'supplementFilter',
    initialState,
    reducers: {
        setSearch: (state, { payload }: PayloadAction<string>) => {
            state.page = 1
            state.search = payload;
        },
        setPage: (state, { payload }: PayloadAction<number>) => {
            state.page = payload;
        },
        setOrderBy: (state, { payload }: PayloadAction<string>) => {
            state.orderBy = payload;
        },
        setOrderDir: (state, { payload }: PayloadAction<string>) => {
            state.orderDir = payload;
        },
        setAllFilters: (state, { payload }: PayloadAction<SupplementFilterStateType>) => {
            return { ...state, ...payload };
        }
    },
});

export const { setSearch, setPage, setOrderBy, setOrderDir, setAllFilters } = supplementFilterSlice.actions;

export default supplementFilterSlice.reducer;

// Main selector
export const supplementFilterSelector = (state: RootState) => state.supplements;

// Individual selectors
export const searchSelector = createSelector(
    [supplementFilterSelector],
    (filters) => filters.search
);

export const pageSelector = createSelector(
    [supplementFilterSelector],
    (filters) => filters.page
);

export const orderBySelector = createSelector(
    [supplementFilterSelector],
    (filters) => filters.orderBy
);

export const orderDirSelector = createSelector(
    [supplementFilterSelector],
    (filters) => filters.orderDir
);

// All filters
export const supplementsSelector = createSelector(
    [supplementFilterSelector],
    (filters) => filters
);
